// src/layouts/MobileNavigation.js
import React from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FaHome,
  FaClipboardList,
  FaTruck,
  FaFileInvoiceDollar,
  FaCalendarAlt,
  FaChartLine
} from 'react-icons/fa';

const MobileNavContainer = styled.nav`
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${props => props.theme.colors.surface};
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: ${props => props.theme.spacing(1)} 0;

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
`;

const NavButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing(1)};
  color: ${props => props.isActive ? props.theme.colors.primary : props.theme.colors.textPrimary};
  background: none;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease;
  position: relative;
  min-width: 64px;

  &:active {
    transform: scale(0.95);
  }

  svg {
    font-size: 1.5rem;
    margin-bottom: ${props => props.theme.spacing(0.5)};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -${props => props.theme.spacing(1)};
    left: 25%;
    right: 25%;
    height: 2px;
    background-color: ${props => props.theme.colors.primary};
    transform: scaleX(${props => props.isActive ? 1 : 0});
    transition: transform 0.3s ease;
  }
`;

const Label = styled.span`
  font-size: ${props => props.theme.typography.fontSize.small};
  transition: color 0.2s ease;
`;

const mobileNavItems = [
  { id: 'dashboard', icon: <FaHome />, label: 'Home', path: '/dashboard' },
  { id: 'leads', icon: <FaClipboardList />, label: 'Leads', path: '/leads' },
  { id: 'estimates', icon: <FaFileInvoiceDollar />, label: 'Quotes', path: '/estimates' },
  { id: 'jobs', icon: <FaCalendarAlt />, label: 'Jobs', path: '/jobs' },
  { id: 'financial', icon: <FaChartLine />, label: 'Financial', path: '/financial' }
];

const MobileNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  return (
    <MobileNavContainer>
      {mobileNavItems.map(item => (
        <NavButton
          key={item.id}
          isActive={isActive(item.path)}
          onClick={() => navigate(item.path)}
        >
          {item.icon}
          <Label>{item.label}</Label>
        </NavButton>
      ))}
    </MobileNavContainer>
  );
};

export default MobileNavigation;